import { useCurrentUser } from "hooks";
import { MILEAGE_CORRECTION_CONFIG } from "../constants";

export const useMileagePermissions = () => {
  const { currentRoleName } = useCurrentUser();

  const canEditMileage =
    currentRoleName &&
    MILEAGE_CORRECTION_CONFIG.ALLOWED_ROLES.includes(currentRoleName as any);

  return {
    canEditMileage,
    currentRoleName
  };
};
